/**
 * 1.68 (196) — a table drawn as a photo of a table with its chairs (the owner's proposal, spec §7). The photos live in
 * `public/tables/` under versioned names; each shape has the seat counts there are photos for. A table gets its shape
 * (the owner's pick, else from the seats as 1.66 draws it: up to four round, more long) and the nearest seat count of
 * that shape — a tie takes the larger. The tile's plate always says the real count. A photo that fails to load falls
 * back to 1.66's drawing (the tile's job).
 */
import type { TableShape } from './tables'

/** The seat counts with a photo, per shape (2026-11-02: round 6, long 8 and 10 still to come). */
export const TABLE_PHOTOS: Record<TableShape, readonly number[]> = { round: [2, 4], square: [2, 4], long: [6] }

export const PHOTO_VERSION = 'v1'

export function tableShapeOf(t: { shape: TableShape | null; seats: number | null }): TableShape {
  if (t.shape) return t.shape
  return t.seats != null && t.seats > 4 ? 'long' : 'round'
}

export function tablePhotoSrc(t: { shape: TableShape | null; seats: number | null }): string {
  const shape = tableShapeOf(t)
  const sizes = TABLE_PHOTOS[shape]
  const want = t.seats != null && t.seats > 0 ? t.seats : 4
  let best = sizes[0]
  for (const n of sizes) {
    const d = Math.abs(n - want)
    const bd = Math.abs(best - want)
    if (d < bd || (d === bd && n > best)) best = n
  }
  return `/tables/${shape}-${best}.${PHOTO_VERSION}.webp`
}
